import * as actionTypes from "../actionTypes";

export const getYatra = payload => ({
    type: actionTypes.GET_YATRA,
    payload
})

export const setYatra = payload => ({
    type: actionTypes.SET_YATRA,
    payload
})

export const createYatra = payload => ({
    type: actionTypes.CREATE_YATRA,
    payload
})

export const updateYatra = payload => ({
    type: actionTypes.UPDATE_YATRA,
    payload
})

export const deleteYatra = payload => ({
    type: actionTypes.DELETE_YATRA,
    payload
})

export const changeYatraStatus = payload => ({
    type: actionTypes.CHANGE_YATRA_STATUS,
    payload
})
